import { reducer } from '@ardoq/rxbeach';
import { PerspectivesEditorState } from '../types';
import { notifyPerspectiveApplied } from 'perspective/actions';

const applyPerspective = (state: PerspectivesEditorState) => ({
  ...state,
});

export const perspectiveAppliedReducer = reducer<PerspectivesEditorState>(
  notifyPerspectiveApplied,
  applyPerspective
);
